import { navigate } from 'gatsby'
import React from 'react'

//* utils
import { OPTIONS } from '../../../../../constants/dateOptions'
import ImgUtil from '../../../../../utils/img.utils'
import formatInlineCode from '../../../../../utils/shortTextFormatting'
import { fillInBlogFields } from './helper'

//* components
import Typography from '../../../../global/typography'
import WrapperImage from '../../../../global/wrapperImage'

export const generateSecondaryArticles = (
  pageContext: any,
  useCase: string,
  defaultLocale: string
) => {
  if (pageContext.secondaryPosts?.length > 0) {
    return pageContext.secondaryPosts.map((post: any, n: number) => {
      const secondaryPost = fillInBlogFields(post.node, useCase, defaultLocale)
      let convertedDate

      if (secondaryPost.date) {
        convertedDate = new Date(secondaryPost.date).toLocaleDateString(defaultLocale, OPTIONS)
      }

      return (
        <div
          onClick={() => navigate(secondaryPost.link)}
          className="TopBlog__Secondary-Article"
          title={secondaryPost.title}
          key={`secondaryPost--${n}`}>
          <div className="TopBlog__Secondary-Article-Img-Container">
            {secondaryPost.src && (
              <WrapperImage
                className="TopBlog__Secondary-Img"
                src={ImgUtil.getResizedImageUrl(secondaryPost.src, '')}
                alt={secondaryPost.altText}
                width={80}
                height={80}
                threshold={650}
              />
            )}
          </div>

          <div className="TopBlog__Secondary-Article-Txt-Container">
            <div className="TopBlog__Secondary-Article-Txt-Category-Date">
              {secondaryPost.category && (
                <Typography className="TopBlog__Secondary-Article-Category" type="captionAlt">
                  {secondaryPost.category}
                </Typography>
              )}

              {secondaryPost && convertedDate && (
                <Typography className="TopBlog__Secondary-Article-Date" type="caption">
                  {convertedDate}
                </Typography>
              )}
            </div>

            {secondaryPost.title && (
              <Typography className="TopBlog__Secondary-Article-Title" type="header6">
                {formatInlineCode(secondaryPost.title)}
              </Typography>
            )}
          </div>
        </div>
      )
    })
  }
}
